import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_xinjianwenjianjia.svg'
import _imports_1 from '@/assets/imgcaptions/icon_suoxiao.svg'
import _imports_2 from '@/assets/imgcaptions/icon_fangda.svg'


const _hoisted_1 = { class: "space" }
const _hoisted_2 = { class: "spaceTop" }
const _hoisted_3 = { class: "operateLeft" }
const _hoisted_4 = { class: "operateSearch" }
const _hoisted_5 = { class: "addFolder" }
const _hoisted_6 = { class: "addFolderBoxTitle" }
const _hoisted_7 = { class: "addFolderBoxName" }
const _hoisted_8 = { class: "addFolderBoxNameInput" }
const _hoisted_9 = { class: "addFolderBoxBtn" }
const _hoisted_10 = { class: "btnBox" }
const _hoisted_11 = { class: "routIndexStyle" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "operateRight" }
const _hoisted_15 = { class: "scaleBox" }
const _hoisted_16 = { class: "scaleBoxInner" }
const _hoisted_17 = { class: "spaceBtm" }

import { ref, onMounted,getCurrentInstance } from 'vue'
// 引入滑块组件
import slider from '@/components/common/slider';
// 引入滑块组件
import pieceList from './pieceList.vue';
import {
    Search,
    ArrowUp,
    View,
    Delete,
    Close,
} from "@element-plus/icons-vue";
import { useRouter ,useRoute} from "vue-router";
import fileApi from '@/api/sound/fileManage.ts';
// 默认参数

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route=useRoute()
// 引入接口
const searchKey=ref('')//查询内容
const addFolderShow=ref(false)//新建文件夹
const parentId=ref(0)//默认在根目录
const pageNum=ref(1)//当前页数
const pageSize=ref(500)//每页条数
const total=ref(0)

const folderName=ref('')//文件夹名称
const multiple=ref(0)//滑块初始倍数
const fileList=ref([])//文件列表
const treeList=ref([])//文件夹路径
onMounted(()=>{
    getFileList()
    // getAllTree()
})
// 获取所有目录
const getAllTree=()=>{
    fileApi.getFolderList().then(res=>{
        console.log(res)
        treeList.value=res.rows
    })
}
const routIndex=ref([
    {
        parentId:'0',
        name:''
    }
])//文件夹列表
// 打开新增文件夹
const openaddFolder=()=>{
    addFolderShow.value=!addFolderShow.value
    folderName.value=''
}
const indexrateData = (num: number) => {
    multiple.value=num
}
// 新增文件夹
const addFolderFun=()=>{
    fileApi.addFolder(folderName.value,parentId.value).then(res=>{
        console.log(res)
        if(res.code==200){
            pageNum.value=1
            fileList.value=[]
            getFileList()
            addFolderShow.value=false
        }
    })
}
// 查询列表
const getFileList=()=>{
    fileApi.getList(pageNum.value,pageSize.value,parentId.value).then(res=>{
        console.log(res)
        if(res.code==200){
            
            total.value=res.total
            res.rows.forEach(item=>{
                if(item.filetype.indexOf('audio')>-1 ||item.filetype.indexOf('application')>-1){
                    item.isplay=false
                    fileList.value.push(item)
                }else{
                    fileList.value.push(item)
                }
            })
            // fileList.value=res.rows
        }
        
    }).catch(err=>{
        fileList.value=[]
    })
}
// 滚动
const scrollAdd=()=>{
    if(pageNum.value*pageSize.value <total.value){
        pageNum.value+=1
        getFileList()
    }
   
}
// 重新获取列表
const reListData=()=>{
    pageNum.value=1
    fileList.value=[]
    getFileList()
}
// 删除
const delCaption=(data:any)=>{
    // let delThis=cities.value.findIndex(item=>item.subtitleId==data[0].subtitleId)
   
    if(data[0].type==0){
        console.log('文件')
        fileApi.delFile(data[0].subtitleId).then((res)=>{
            console.log(res)
            fileList.value.splice(data[1],1)
            // if(delThis>=0){
            //     cities.value.splice(delThis,1)
            //     localStorage.setItem('projectoften', JSON.stringify(cities.value))
            // }
        })
    }else {
        console.log('文件夹')
        fileApi.addFolder(data[0].id).then((res)=>{
            console.log(res)
            fileList.value.splice(data[1],1)
        })
    }
}
// 重命名
const reNameFun=(data:any)=>{
    console.log(data)
    console.log('重命名')
    
}
// 打开问价夹
const openFolder=(data:any)=>{
    console.log('打开问价夹')
    searchKey.value=""
    fileList.value=[]
    let selFolder=JSON.parse(data)
    routIndex.value.push(
        {
            parentId:selFolder.fileId,
            name:selFolder.filename
        }
    )
    parentId.value=selFolder.fileId
    reListData()
}
// 跳转查询对应文件
const toThisFolder=(item:any,index:number)=>{
    console.log('跳转查询对应文件')
    console.log(item)
    routIndex.value.splice((index+1),(routIndex.value.length-1))
    pageNum.value=1
    parentId.value=item.parentId
    searchKey.value=""
    reListData()
}
// 查询
const getListCaption=()=>{
    pageNum.value=1
    parentId.value=0
    fileApi.getListKey(pageNum.value,pageSize.value,parentId.value,searchKey.value).then(res=>{
        console.log(res)
        fileList.value=res.rows
    }).catch(err=>{
        fileList.value=[]
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "搜索",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event))
          }, null, 512), [
            [_vModelText, searchKey.value]
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_el_icon, {
              onClick: _withModifiers(getListCaption, ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tooltip, {
            content: "新建文件夹",
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _withModifiers(openaddFolder, ["stop"])
              })
            ]),
            _: 1
          }),
          (addFolderShow.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "addFolderBox",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "新建项目文件夹", -1)),
                  _createElementVNode("span", {
                    class: "closeBtn",
                    onClick: _withModifiers(openaddFolder, ["stop"])
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Close))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "addFolderBoxNameTitle" }, "文件夹名称", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "请输入文件夹名称",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((folderName).value = $event))
                    }, null, 512), [
                      [_vModelText, folderName.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: "btnOk",
                      onClick: _withModifiers(addFolderFun, ["stop"])
                    }, "确定")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routIndex.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("span", {
                onClick: _withModifiers(($event: any) => (toThisFolder(item,index)), ["stop"])
              }, _toDisplayString(item.name==''?'根目录':item.name), 9, _hoisted_12),
              _cache[7] || (_cache[7] = _createTextVNode()),
              (index!=(routIndex.value.length-1))
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " / "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_tooltip, {
            content: "缩小",
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                class: "scaleBoxSmall",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (multiple.value--), ["stop"]))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(slider), {
              num: multiple.value,
              max: 100,
              onUpdataNum: indexrateData
            }, null, 8, ["num"])
          ]),
          _createVNode(_component_el_tooltip, {
            content: "放大",
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                class: "scaleBoxLarge",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (multiple.value++), ["stop"]))
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_scrollbar, {
        height: "100%",
        onScroll: scrollAdd
      }, {
        default: _withCtx(() => [
          _createVNode(pieceList, {
            list: JSON.stringify(fileList.value),
            size: multiple.value,
            onReName: reNameFun,
            onReListData: reListData,
            onOpenFolder: openFolder
          }, null, 8, ["list", "size"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})